import { pantryColors, pantryTypography } from '@pantry/ui'
import type React from 'react'

// Shared form-control styles for the Email-Marketing dialogs. Mirrors the
// plain-input styling used by the members AdjustPointsModal so the marketing
// modals visually match the rest of the Loyalty surface (no Formik / MUI
// TextField — inputs are native + inline-styled).

const p = pantryColors

export const labelStyle: React.CSSProperties = {
  display: 'block',
  fontSize: 12,
  fontWeight: 600,
  color: p.gray[600],
  marginBottom: 6,
}

export const inputStyle: React.CSSProperties = {
  boxSizing: 'border-box',
  width: '100%',
  padding: '8px 12px',
  border: `1px solid ${p.gray[200]}`,
  borderRadius: 6,
  fontSize: 13,
  color: p.gray[700],
  background: p.white,
  outline: 'none',
}

export const helpTextStyle: React.CSSProperties = {
  fontSize: 11.5,
  color: p.gray[400],
  marginTop: 4,
}

export const errorTextStyle: React.CSSProperties = {
  fontSize: 12,
  color: '#B91C1C',
}

export const sectionLabelStyle: React.CSSProperties = {
  fontSize: 13,
  fontWeight: 600,
  color: p.gray[700],
}

// Constrains a tab's content (and its tables) to a readable max width, centered.
// Applied to the Tracking / Email Templates / Campaigns & Flows tab roots.
export const contentWrapperStyle: React.CSSProperties = {
  maxWidth: 1000,
  width: '100%',
  margin: '0 auto',
  display: 'flex',
  flexDirection: 'column',
  gap: 20,
}

// ── Shared card + table styles (Campaigns / Flows tabs) ─────────────────────

export const cardStyle: React.CSSProperties = {
  background: p.white,
  border: `1px solid ${p.gray[200]}`,
  borderRadius: 10,
  fontFamily: pantryTypography.fontFamily,
}

export const thStyle: React.CSSProperties = {
  textAlign: 'left',
  padding: '10px 16px',
  fontSize: 11,
  fontWeight: 700,
  textTransform: 'uppercase',
  letterSpacing: '0.06em',
  color: p.gray[400],
  borderBottom: `1px solid ${p.gray[200]}`,
  background: p.gray[50],
  whiteSpace: 'nowrap',
}

export const tdStyle: React.CSSProperties = {
  padding: '12px 16px',
  fontSize: 13.5,
  color: p.gray[800],
  borderBottom: `1px solid ${p.gray[100]}`,
  verticalAlign: 'middle',
}
